export default {
    'ERROR-GET-ORGANIZATION-ADMIN': {
        'ORGANIZATION-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Organisation introuvable.",
                en: "Organization not found.",
            },
            redirectPath: '/',
        },
    },
    'ERROR-UPDATE-ORGANIZATION-ADMIN': {
        'ORGANIZATION-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Organisation introuvable.",
                en: "Organization not found.",
            },
            redirectPath: '/',
        },
        'NO-FIELDS-TO-UPDATE': {
            actionType: 'toast',
            message: {
                fr: "Aucun champ à mettre à jour.",
                en: "No fields to update.",
            },
        },
    },
    'ERROR-POST-PICTURE': {
        'FILE-INCOMPLETE': {
            actionType: 'toast',
            message: {
                fr: "Fichier incomplet. Veuillez réessayer.",
                en: "Incomplete file. Please try again.",
            },
        },
        'NO-FILE-TO-UPLOAD': {
            actionType: 'toast',
            message: {
                fr: "Aucun fichier à télécharger.",
                en: "No file to upload.",
            },
        },
        'INVALID-URL-NAME': {
            actionType: 'toast',
            message: {
                fr: "Nom de champ d'URL invalide.",
                en: "Invalid URL field name.",
            },
        },
        'NO-PICTURE-URL': {
            actionType: 'toast',
            message: {
                fr: "Échec du téléchargement de l'image.",
                en: "Failed to upload the picture.",
            },
        },
    },
};
